<router-outlet></router-outlet>
@if(authloader.authenticationLoader()){
   <div class="verify-loader-container">
      <div class="verify-loader">
          <div class="verify-circle"></div>
          <img src="assets/zen-builder-logo.png" class="verify-logo" width="50" height="50" alt="zen-logo">
      </div>
      <div class="verify-text">Verifying user</div>
      <div class="verify-subtext">Please wait...</div>
    </div>
}